module.exports = __webpack_public_path__ + "static/mailgun-create-key-b1e7a479394d8d452696a28991ee7ef6.png";